const removeErrorsOnFields = ($inputs, defaultParentSelector = ".field-group") => {
    $inputs.forEach($input => {
        let parentSelector = $input.dataset.statusParentSelector
        parentSelector = parentSelector && parentSelector !== "" ? parentSelector : defaultParentSelector
        let $parent = $input.closest(parentSelector)
        if ($parent) {
            $parent.classList.remove("has-error")
        }
    })
}

const cleanInputsValues = ($inputs) => {
    $inputs = $inputs.length ? $inputs : [$inputs]
    $inputs.forEach($input => {
        if ($input.getAttribute("type") === "checkbox" || $input.getAttribute("type") === "radio") {
            $input.checked = $input.dataset.initialCheck ? parseInt($input.dataset.initialCheck) : false
        } else {
            $input.value = $input.dataset.initialValue ? $input.dataset.initialValue : ""
        }
    })
}

const addErrorOnField = ($input, inputInvalidMessageSelector, errorMessage = "", defaultParentSelector = ".field-group") => {
    let parentSelector = $input.dataset.statusParentSelector
    parentSelector = parentSelector && parentSelector !== "" ? parentSelector : defaultParentSelector
    let $parent = $input.closest(parentSelector)
    if ($parent) {
        $parent.classList.add("has-error")
        const $message = $parent.querySelector(inputInvalidMessageSelector)
        if ($message) {
            $message.innerHTML = errorMessage
        }
    }
}

const isValideEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
}

const inputIsValidEmail = ($field) => {
    return isValideEmail($field.value)
}

const inputIsNotEmpty = ($field) => {
    return !(!$field.value || $field.value === "")
}

const checkIfFieldsAreValid = ($fields) => {
    const errors = []
    $fields.forEach($field => {
        const type = $field.getAttribute("type")
        let hasErrors = false
        let minLength = $field.getAttribute("minlength")
        let maxLength = $field.getAttribute("maxlength")


        if (type === "email") {

            // Check if valid email
            hasErrors = !inputIsValidEmail($field)

        } else if ( type === "tel" ) {

            let value = $field.value
            value = value.replace(/\s/g, "") // remove white spaces
            value = value.replace(/\+/g, "") // remove "+"
            value = value.replace(/\(/g, "") // remove "("
            value = value.replace(/\)/g, "") // remove ")"
            hasErrors = value.length < 9 || /\D/gi.test(value)

        } else if (type === "checkbox") {


            // System witch force a group of checkboxes to not have "false" as a checked input
            if ($field.dataset.checkboxRefuseFalse !== undefined) {

                let refuseFalse = parseInt($field.dataset.checkboxRefuseFalse)
                refuseFalse = isNaN(refuseFalse) ? false : refuseFalse

                if (refuseFalse) {

                    const name = $field.getAttribute("name")
                    const $checkboxes = [...document.querySelectorAll(`input[type="checkbox"][name="${name}"]`)]

                    if ( $checkboxes.length ) {
                        let checkedValue = undefined
                        $checkboxes.forEach($checkbox => $checkbox.checked ? checkedValue = $checkbox.value : null )
                        console.log("checkedValue", checkedValue)
                        hasErrors =  checkedValue === "false"
                    }

                }

            }


        } else {

            // Check if not empty
            hasErrors = !inputIsNotEmpty($field)

        }

        if (minLength && !hasErrors) {
            hasErrors = !(String($field.value).length >= minLength)
        }

        if (maxLength && !hasErrors) {
            hasErrors = !(String($field.value).length <= maxLength)
        }

        if (hasErrors) {
            errors.push($field)
        }

    })
    return errors
}

export {
    removeErrorsOnFields,
    cleanInputsValues,
    addErrorOnField,
    inputIsNotEmpty,
    checkIfFieldsAreValid
}
